module.exports = __webpack_public_path__ + "img/itproof.d0825f2e.svg";